<template>
  <Body class="page-signature" />

  <section class="section-container section-title">
    <div class="headline flex-center flex-column">
      <h2 class="sub" v-html="$t('어머니사랑과평화의날brun국제관용의날기념캠페인')" />
      <h1 v-if="locale === 'ko'" class="tit">
        <picture class="img">
          <source media="(max-width:767px)" srcset="/images/signature_02_m_new.svg">
          <img src="/images/signature_02_new.svg" alt="평화를 부르는 ‘어머니 사랑의 언어’ 지지서명">
        </picture>
        <span class="blind">평화를 부르는 ‘어머니 사랑의 언어’ 지지서명</span>
      </h1>
      <!-- 한국어 외 다국어일 떄는 텍스트로 -->
      <h1 v-else class="tit" v-html="$t('2024평화를부르는어머니사랑의언어지지서명')" />
    </div>
  </section>

  <section class="section-container section-sign">
    <div class="container sign-form">
      <div class="txt">
        <p
          v-html="
            $t('이기주의의심화로존중과포용이퇴색되어가고br갈등과폭력이범람하는시대br인류는어느때보다평화를갈망하')
          "
        />
        <p
          v-html="
            $t('태어나처음어머니품에서느낀위로와안식은br국가민족문화를넘어인류가공감하는평화의근원입니다br희생과')
          "
        />
        <p
          v-html="$t('하나님의교회세계복음선교협회는올해설립60주년을맞아br11월1일을b어머니사랑과평화의날b로지정하')"
        />
        <p
          v-html="$t('2024년주제는평화를부르는어머니사랑의언어입니다br가정학교직장이웃사회에서따뜻한언어문화를조성해')"
        />
        <p v-html="$t('작은실천이모여세상을변화시킬수있도록아낌없는지지를보내주세요')" />
      </div>
      <div class="form">
        <div class="txtbox">
          <h3 class="tit">
            {{ $t('서명하기') }}
          </h3>
          <p
            v-html="
              $t('본인은평화를부르는어머니사랑의언어캠페인이전지구촌에선한문화로확산되고어머니사랑과평화의날이세계가공')
            "
          />
        </div>

        <div class="inputs">
          <!-- 필수항목 : 이름, 이메일
        필수항목을 체크하지 않았으면 하단 토스트 알림을 띄워주세요. -->
          <input ref="nameInput" v-model="name" type="text" :placeholder="`${$t('이름')}*`">
          <input ref="emailInput" v-model="email" type="text" :placeholder="`${$t('이메일')}*`">
          <!-- 국가선택 -->
          <div class="droplayer">
            <div id="dropwrap" class="dropwrap" :class="{ active: isDropdownVisible }">
              <input
                id="default_input"
                readonly
                :placeholder="`${$t('국가')}`"
                :value="selectedCountryNm"
                @click="toggleDropdown"
              >
            </div>
            <div v-show="isDropdownVisible" id="droplist" class="dropdown-lists">
              <input
                ref="searchInput"
                v-model="searchCountry"
                type="text"
                :placeholder="$t('search')"
                class="real-search"
                @input="handleInput"
              >
              <div class="listbox">
                <span
                  v-for="country in filterCountries"
                  :key="country.country_cd"
                  @click="chooseCountry(country.country_nm, country.country_cd)"
                >{{ country.country_nm }}</span>
              </div>
            </div>
          </div>

          <div v-if="!userSignatureInfo" class="form-check">
            <input id="write-agree" v-model="agree" class="form-check-input" type="checkbox" name="agreement">
            <label class="form-check-label" for="write-agree">
              <span class="check-ico">
                <svg viewBox="0 0 12 9">
                  <polyline points="1 5 4 8 11 1" />
                </svg>
              </span>
              <span class="cb-label" v-html="$t('b개인정보수집이용b에동의합니다')" />
            </label>
          </div>
        </div>

        <!-- 이미 서명한 이력이 있는 경우, 로그인 후에 안내 무구 보이기 -->
        <div v-if="!!userSignatureInfo" class="guide-text">
          {{ userSignatureInfo }}
        </div>

        <div class="sign">
          <button type="button" name="button" class="btn-sign" @click="fnSign()">
            {{ $t('서명하기') }}
          </button>
          <cite v-html="$t('대외협력및홍보목적으로사용되며그외의용도로활용되거나유출되지않습니다')" />
        </div>
        <div class="illust" />
      </div>
    </div>
  </section>

  <div v-if="signDone" class="pop pop-sign-done">
    <div class="popin">
      <div class="flowerBook">
        <div class="book" />
        <div class="pencil" />
        <div class="leave leaves1" />
        <div class="leave leaves2" />
        <div class="leave leaves3" />
        <div class="leave leaves4" />
        <div class="heart heart1" />
        <div class="heart heart2" />
        <div class="heart heart3" />
        <div class="leave leaves5" />
        <div class="leave leaves6" />
        <div class="heart heart4" />
        <div class="heart heart5" />
        <div class="heart heart6" />
        <div class="heart heart7" />
        <div class="heart heart8" />
        <div class="heart heart9" />
        <div class="leave leaves7" />
        <div class="heart heart10" />
        <div class="heart heart11" />
        <div class="heart heart12" />
        <div class="heart heart13" />
        <div class="heart heart14" />
        <div class="leave leaves8" />
        <div class="heart heart15" />
        <div class="heart heart16" />
        <div class="heart heart17" />
        <div class="heart heart18" />
        <div class="heart heart19" />
        <div class="heart heart20" />
        <div class="heart heart21" />
        <div class="heart heart22" />
        <div class="heart heart23" />
        <div class="heart heart24" />
      </div>
      <div class="title">
        {{ $t('참여해주셔서감사합니다') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// 참여완료 모달

// GSAP ----------
import gsap from 'gsap'

const { $t } = useNuxtApp()

useHead({
  title: `${$t('지지서명')} - ${$t('어머니사랑과평화의날캠페인')}`,
  link: [
    { rel: 'stylesheet', href: `/css/signature.css?${useBuildTime()}` },
    { rel: 'stylesheet', href: `/css/style_add.css?${useBuildTime()}` },
  ],
})
const { locale } = useI18n()

const name = ref('')
const email = ref('')
const nameInput = ref<HTMLInputElement | null>(null)
const emailInput = ref<HTMLInputElement | null>(null)

const userSignatureInfo = ref('')
const agree = ref(false)
const countries = ref<Country[]>([])
const searchCountry = ref('')
const selectedCountryNm = ref('')
const selectedCountryCd = ref('')
const isDropdownVisible = ref(false)
const searchInput = ref<HTMLInputElement | null>(null)

const { showSnackbar } = useSnackbar()
const { fetchCountries } = useCountries()

const { data } = await fetchCountries()
if (data.value) {
  countries.value = data.value
}

async function userSignature() {
  return await useAPI<{
    name: string
    email: string
    countryNm: string
    createdAt: string
  }>('/hml/v1/me/support-signature', {
    method: 'GET',
  })
}

const signDone = ref(false)

const { data: signatureData } = await userSignature()
if (signatureData.value) {
  name.value = signatureData.value.name
  email.value = signatureData.value.email
  selectedCountryNm.value = signatureData.value.countryNm
  const date = new Date(signatureData.value.createdAt)

  // 날짜 포맷팅
  const formattedDate = formatIntlDate(date, locale.value)

  userSignatureInfo.value = $t('2024년0월0일에이미서명하셨습니다').replace('{}', formattedDate)
}

// 필터링된 국가 리스트
const filterCountries = computed(() => {
  if (!searchCountry.value) {
    return countries.value
  }
  return countries.value.filter((country) => {
    return country.country_nm.toLowerCase().includes(searchCountry.value.toLowerCase())
  })
})

// 선택된 국가를 업데이트하는 함수
function chooseCountry(name: string, cd: string) {
  selectedCountryNm.value = name
  selectedCountryCd.value = cd
  isDropdownVisible.value = false
}

async function fnSign() {
  if (userSignatureInfo.value) {
    showSnackbar(userSignatureInfo.value)
    return
  }
  if (name.value === '') {
    showSnackbar($t('이름을입력해주세요'))
    nameInput.value?.focus()
    return
  }
  if (email.value === '') {
    showSnackbar($t('이메일을입력해주세요'))
    emailInput.value?.focus()
    return
  }

  // 이메일 형식 검증
  const emailRegex = /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/
  if (!emailRegex.test(email.value)) {
    showSnackbar($t('올바른이메일형식을입력해주세요'))
    emailInput.value?.focus()
    return
  }

  if (!agree.value) {
    showSnackbar($t('개인정보수집및이용에동의해야합니다'))
    return
  }

  const requestData = {
    name: name.value,
    email: email.value,
    countryCd: selectedCountryCd.value,
    countryNm: selectedCountryNm.value,
  }
  const { data } = await useAPI<{
    createdAt: string
  }>('/hml/v1/me/support-signature', {
    method: 'POST',
    body: JSON.stringify(requestData),
  })

  if (data.value) {
    userSignatureInfo.value = $t('참여해주셔서감사합니다')

    signDone.value = true
    nextTick(() => {
      completeSignature()
    })
  }
}

function handleInput(event: any) {
  searchCountry.value = event.target.value
}

function toggleDropdown() {
  isDropdownVisible.value = !isDropdownVisible.value
  if (isDropdownVisible.value) {
    nextTick(() => {
      searchInput.value?.focus()
    })
  }
}

// 모달 닫기
function closeModal() {
  gsap.to('.pop-sign-done', {
    opacity: 0,
    display: 'none',
    duration: 0.3,
    onComplete: () => {
      signDone.value = false
    },
  })
}

// 서명 완료
function completeSignature() {
  const tl1 = gsap.timeline({
    onComplete: () => {
      closeModal()
    },
  })
  tl1.add('sign-complete')

  tl1.from(
    '.flowerBook .book',
    {
      duration: 1.5,
      opacity: 0,
      scale: 0.5,
      ease: 'elastic.out(1, 0.5)',
    },
    'sign-complete',
  )
  tl1.from(
    '.flowerBook .pencil',
    {
      duration: 1.7,
      opacity: 0,
      x: -10,
      y: -15,
      rotation: -20,
      ease: 'elastic.out(1, 0.5)',
      delay: 0.3,
    },
    'sign-complete',
  )
  tl1.staggerFrom(
    '.flowerBook .heart',
    1.5,
    {
      scale: 0,
      x: -5,
      y: 20,
      ease: 'elastic.out(1.4, 0.3)',
      delay: 0.5,
    },
    0.04,
    'sign-complete',
  )
  tl1.staggerFrom(
    '.flowerBook .leave',
    2,
    {
      scale: 0,
      x: -5,
      y: 20,
      rotation: -90,
      ease: 'power2.out',
      delay: 1,
    },
    0.1,
    'sign-complete',
  )
}
</script>
